import React, { useEffect, useContext } from 'react';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import { Column } from '../Column';
import { ColumnViewContext } from '../context';
import { getStyles } from './styles';

export function Tree(props: TreeProps) {
  const { root, setRoot,  setSelections } = useContext(ColumnViewContext);
  const theme = useTheme();
  const styles = getStyles(theme);

  useEffect(() => {
    setRoot([...props.nodes]);
    setSelections(props.selections);

    return () => {
      setRoot([]);
      setSelections(new Set());
    }
  }, [ props.nodes, props.selections, setRoot, setSelections ]);

  return (
    root && root.length > 0 ? 
    <Box sx={{ overflowX: 'auto' }}>
      <Box component="table" sx={styles.columnViewTree}>
        <tbody>
          <Column
            nodes={root}
            getNodeChildren={props.getNodeChildren}
            getRootNode={props.getRootNode}
            onCheck={props.onCheck}
            selectedNode={props.selectedNode}
          />
        </tbody>
      </Box>
    </Box>
    : null
  )
}